import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import account from './account/account.routes';
import activitylogs from './activitylogs/activity.routes';
import agent from './agents/agent.routes';
import assignmentPolicy from './assignmentPolicy/assignmentPolicy.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import automation from './automation/automation.routes';
import emailTemplates from './emailTemplates/emailTemplates.routes';
import auditlogs from './auditlogs/audit.routes';
import billing from './billing/billing.routes';
import canned from './canned/canned.routes';
import inbox from './inbox/inbox.routes';
import integrations from './integrations/integrations.routes';
import labels from './labels/labels.routes';
import macros from './macros/macros.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import sla from './sla/sla.routes';
import teams from './teams/teams.routes';
import profile from './profile/profile.routes';
import assistant from './assistant/assistant.routes';
import knowledgebases from './knowledgebase/knowledgebase.routes';
import customRoles from './customRoles/customRole.routes';
import security from './security/security.routes';
import spaces from './spaces/spaces.routes';
import resources from './resources/resources.routes';
import experiences from './experiences/experiences.routes';
import bookingWidgets from './bookingWidgets/bookingWidgets.routes';
import workflows from './workflows/workflows.routes';
import eventStatuses from './eventStatuses/eventStatuses.routes';
import eventPortals from './eventPortals/eventPortals.routes';
import pricing from './pricing/pricing.routes';
import captain from './captain/captain.routes';
import dataHub from './dataHub/dataHub.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
      redirect: to => {
        if (
          store.getters.getCurrentRole === 'administrator' &&
          store.getters.getCurrentCustomRoleId === null
        ) {
          return { name: 'general_settings_index', params: to.params };
        }

        return { name: 'canned_list', params: to.params };
      },
    },
    ...account.routes,
    ...activitylogs.routes,
    ...agent.routes,
    ...assignmentPolicy.routes,
    ...agentBot.routes,
    ...attributes.routes,
    ...automation.routes,
    ...auditlogs.routes,
    ...emailTemplates.routes,
    ...billing.routes,
    ...canned.routes,
    ...inbox.routes,
    ...integrations.routes,
    ...labels.routes,
    ...macros.routes,
    ...reports.routes,
    ...sla.routes,
    ...teams.routes,
    ...assistant.routes,
    ...knowledgebases.routes,
    ...customRoles.routes,
    ...profile.routes,
    ...security.routes,
    ...spaces.routes,
    ...resources.routes,
    ...experiences.routes,
    ...bookingWidgets.routes,
    ...workflows.routes,
    ...eventStatuses.routes,
    ...eventPortals.routes,
    ...pricing.routes,
    ...captain.routes,
    ...dataHub.routes,
  ],
};
